/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_BeforeInputs */

const en_gc_editor_before = /** @type {(inputs: Gc_Editor_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before you begin`)
};

const zh_gc_editor_before = /** @type {(inputs: Gc_Editor_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始之前`)
};

/**
* | output |
* | --- |
* | "Before you begin" |
*
* @param {Gc_Editor_BeforeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_before = /** @type {((inputs?: Gc_Editor_BeforeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_BeforeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_before(inputs)
	return zh_gc_editor_before(inputs)
});
export { gc_editor_before as "gc.editor.before" }